import { FC } from 'react';
import { Box, Stepper, Step, StepLabel, StepperProps } from '@mui/material';

type IdecoStepperProps = Omit<StepperProps, 'children'> & {
  steps: string[];
};

/**
 * @summary Компонент Для отображения степов
 *
 * @see https://mui.com/components/steppers/#main-content
 */
export const IdecoStepper: FC<IdecoStepperProps> = ({ steps, ...stepperProps }) => {
  return (
    <Box sx={{ width: '100%' }}>
      <Stepper {...stepperProps}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};
